import { useQueryClient } from '@tanstack/react-query';
import { maxEndppointOIDCProvidersQueryOptions } from '#api/endpoint-oidc-providers.queries.ts';

export function useGetProvidersForDomain() {
  const queryClient = useQueryClient();

  return async function getProvidersFor(domainId: string) {
    try {
      const { data: allProviders } = await queryClient.fetchQuery(maxEndppointOIDCProvidersQueryOptions);
      return allProviders.filter((p) => p.domainID === domainId);
    } catch {
      return [];
    }
  };
}
